namespace $.$$ {
	
	$mol_style_define( $mol_bigint_field, {
		
		maxWidth: '100%',

		String: {
			flex: {
				grow: 1,
				shrink: 1,
				basis: `7rem`
			},
			width: `7rem`,
		},
		
	} )
	
}
